import React from 'react';
import {Flex} from '@chakra-ui/react';

export const AuthCard = ({children}: {children: React.ReactNode}) => {
    return (
        <Flex
            flexDir="column"
            alignItems="stretch"
            w="full"
            maxW="470px"
            borderRadius="8px"
            bgColor="#ffffff"
            px={{ base: '1.5rem', md: '2.5rem' }}
            py={{ base: '2rem', md: '2.5rem' }}
            mx="auto"
            mt={{ base: '48px', md: '80px' }}
            mb="4rem"
            boxShadow="0 28px 51px 0 rgb(5 5 5 / 8%)"
            position="relative"
        >
            {children}
        </Flex>
    );
};
